import create from 'zustand'
import { ObjectiveDto } from '../../../types'
import { BonusDistributionModalState, BonusDistributionObjective } from './types'
import { distributeEqually, formatObjectives } from './utils'

const initialValues = {
  isModalOpen: false,
  totalBonus: 0,
  paidOutBonus: 0,
  plannedBonus: 0,
  objectives: [],
}

export const useBonusDistributionModalStore = create<BonusDistributionModalState>((set) => ({
  ...initialValues,

  openDistributionModal: (
    meetingId: string,
    objectives: ObjectiveDto[],
    totalBonus: number,
    paidOutBonus: number,
    plannedBonus: number,
  ) => {
    set({
      meetingId,
      isModalOpen: true,
      objectives: formatObjectives(objectives, totalBonus - plannedBonus - paidOutBonus),
      totalBonus,
      paidOutBonus,
      plannedBonus,
    })
  },

  setObjectives: (objectives: BonusDistributionObjective[]) => set({ objectives }),

  distributeBonusEqually: () =>
    set((state) => {
      const updatedObjectives = distributeEqually(state.objectives, Math.abs(state.totalBonus - state.plannedBonus))
      set({ objectives: updatedObjectives })
    }),

  closeDistributionModal: () => set({ ...initialValues }), // reset store when modal closes
}))
